import { FieldOptionBase } from 'module/api/field/types';
import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import { SingleSelectField } from 'module/types/filter-field/field/filterable-field';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import { SelectFieldOption } from 'module/ui/components/molecules/field-editable-value/option';
import { StyledSelect } from 'module/ui/components/molecules/field-editors/components/components';
import { forwardRef } from 'react';
import { EditableProps } from './editable-props';

interface Props extends Partial<EditableProps<number>> {
  field: SingleSelectField;
  menuIsOpen?: boolean;
}

export const SingleSelectFieldValue = forwardRef<HTMLDivElement, Props>(
  ({ field, editable, onChange }, ref) => {
    const {
      options: { activeOptions, allOptions },
    } = optionsTransformer(field);

    return !editable ? (
      field.value == null ? (
        <NoValue />
      ) : (
        <SelectFieldOption
          option={allOptions.find((x) => x.value === field.value)!}
        />
      )
    ) : (
      <StyledSelect
        ref={ref}
        type="tag"
        isClearable
        menuIsOpen
        options={activeOptions}
        value={
          field?.value == null
            ? null
            : allOptions.find((x) => x.value === field?.value)
        }
        onChange={(latest: FieldOptionBase) => onChange?.(latest?.value)}
      />
    );
  },
);

export const SingleSelectFieldRenderer = forwardRef<HTMLDivElement, Props>(
  ({ field, editable, onChange, menuIsOpen }, ref) => {
    const {
      options: { activeOptions, allOptions },
    } = optionsTransformer(field);

    return (
      <StyledSelect
        placeholder="Select an option"
        ref={ref}
        type="tag"
        isClearable
        menuIsOpen={menuIsOpen}
        options={activeOptions}
        editable={editable}
        value={
          field?.value == null
            ? null
            : allOptions.find((x) => x.value === field?.value)
        }
        onChange={(latest: FieldOptionBase) => onChange?.(latest?.value)}
      />
    );
  },
);

SingleSelectFieldValue.displayName = 'SingleSelectFieldValue';
SingleSelectFieldRenderer.displayName = 'SingleSelectFieldRenderer';
